/**
 * @typedef {import('./VectorPrimitive.js').PolygonStyle} PolygonStyle
 */
import VectorPrimitive from './VectorPrimitive.js';

class NoFlyZone extends VectorPrimitive {
  constructor(options) {
    options = options ?? {};
    options.polygonStyle = {
      fill: true,
      color: Cesium.Color.fromCssColorString('#ee2c2c80'),
      outline: true,
      outlineColor: Cesium.Color.fromCssColorString('#ee2c2c'),
      outlineWidth: 3,
      ...options.polygonStyle,
    };
    super(options);
  }

  /**
   * 处理DataSource
   * @override
   */
  _resolveDataSource() {
    const entities = this._dataSource.entities.values;

    const labelItems = [];

    this._resolvePolygon(entities, labelItems);

    if (labelItems.length > 0) {
      this._labelCollection = new Cesium.LabelCollection({
        blendOption: Cesium.BlendOption.OPAQUE,
      });
      for (let i = 0; i < labelItems.length; i++) {
        const labItem = labelItems[i];
        this._labelCollection.add(labItem);
      }
      this._collection.add(this._labelCollection);
    }

    this._dataSource = undefined;
  }
}

export default NoFlyZone;
